import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';

import { FormData, FormComponent } from '../../form/index';

@Component({
  selector: 'uex-form-bar',
  templateUrl: './form-bar.component.html'
})
export class FormBarComponent {
  @ViewChild(TemplateRef, { static: true }) content: TemplateRef<any>;
  @ViewChild('uexForm', { static: false }) form: FormComponent;

  @Output('uexSubmit') uexSubmit: EventEmitter<any> = new EventEmitter();

  @Input('class') cssClass: any;
  @Input('hidden') hidden = false;
  @Input('form') formSettings: FormData;
  @Input('hasButton') hasButton = true;
  @Input('buttonLabel') buttonLabel: string;
  @Input('buttonIcon') buttonIcon = 'search';

  constructor() { }

  public hasForm(): boolean {
    return this.formSettings ? true : false;
  }

  public hasFormButton(): boolean {
    return this.formSettings && this.hasButton ? true : false;
  }

  public onSubmit(event) {
    this.uexSubmit.emit(event);
  }
}
